module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-cc25bcb1.png";